import React, { useMemo, useState, useEffect } from "react";
import './SyncService.scss';
import { MaterialReactTable } from "material-react-table";
import { useDispatch, useSelector } from "react-redux";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import FormControl from "@mui/material/FormControl";
import { Select, MenuItem } from "@mui/material";
import { Button, Tooltip, Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography, TextField } from "@material-ui/core";
import { Add as AddIcon, Delete as DeleteIcon } from "@mui/icons-material";
import SyncServiceDialog from "./SyncServiceDialog";
import { getWellActiveDevice, getSyncService, actionSyncService, downloadSyncService } from "../../Utils/actions/yh";
import { getApiUserRoles } from "../../Utils/actions";
import DownloadIcon from "@mui/icons-material/Download";
import InfoIcon from "@mui/icons-material/Info";
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import CircularProgress from '@mui/material/CircularProgress';
import { SearchOutlined } from '@material-ui/icons';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import RefreshIcon from "@mui/icons-material/Refresh";

const SyncService = () => {
    const dispatch = useDispatch();
    const {
        getSyncData,
        getSyncAction
    } = useSelector((state) => state.yh);
    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize, setPageSize] = useState(sessionStorage.getItem('syncPageSize') ? sessionStorage.getItem('syncPageSize') :10);
    const [openDialog, setOpenDialog] = useState(false);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const [deleteConfirmId, setDeleteConfirmId] = useState({});
    const [selectedRow, setSelectedRow] = useState(null);
    const [infoOpen, setInfoOpen] = useState(false);
    const [clickStart, setClickStart] = useState(false);
    const [actionType, setActionType] = useState('');
    const [searchQuery, setSearchQuery] = useState("");
    const [iconStates, setIconStates] = useState({});
    const [iconName, setIconName] = useState('');
    const [columnName, setColumnName] = useState('');
    const icons = [<ImportExportIcon />, <ArrowUpwardIcon />, <ArrowDownwardIcon />];
    const Data = getSyncData.lenth > 0 ? getSyncData.data : '';

    const handleClick = () => {
        setOpenDialog(true);
    }

    const handleClose = () => {
        setOpenDialog(false);
    }
    useEffect(() => {
        dispatch(getApiUserRoles(sessionStorage.getItem("username")));
    }, []);
    useEffect(() => {
        dispatch(getWellActiveDevice("", pageSize, pageIndex))
    }, [])
    useEffect(() => {
        dispatch(getSyncService(pageSize, pageIndex, searchQuery, iconName, columnName))
    }, [pageSize, pageIndex, searchQuery, iconName, columnName])

    useEffect(() => {
        dispatch(actionSyncService(actionType, selectedRow))
    }, [actionType, selectedRow])



    const handleIconToggle = (name) => {
        const currentIconIndex = iconStates[name] || 0;
        const newIndex = (currentIconIndex + 1) % icons.length;

        setIconStates({
            [name]: newIndex
        });

        setColumnName(name);
        if (newIndex === 0) setIconName('');
        else if (newIndex === 1) setIconName('ASC');
        else if (newIndex === 2) setIconName('DES');
    };

sessionStorage.setItem('syncPageSize', pageSize);


    const columns = useMemo(
        () => [
            {
                accessorKey: "rig",
                header: (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="body2">Rig</Typography>
                        <IconButton onClick={() => handleIconToggle("rig")} size="small" sx={{ ml: 1 }}>
                            {icons[iconStates["rig"] || 0]}
                        </IconButton>
                    </Box>
                ),
            },
            {
                accessorKey: "well",
                header: (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="body2">Well</Typography>
                        <IconButton onClick={() => handleIconToggle("well")} size="small" sx={{ ml: 1 }}>
                            {icons[iconStates["well"] || 0]}
                        </IconButton>
                    </Box>
                ),
            },
            {
                accessorKey: "dataProvider",
                header: (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="body2">Data Provider</Typography>
                        <IconButton onClick={() => handleIconToggle("dataProvider")} size="small" sx={{ ml: 1 }}>
                            {icons[iconStates["dataProvider"] || 0]}
                        </IconButton>
                    </Box>
                ),
            },
            {
                accessorKey: "endPointType",
                header: (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="body2">Sync Type</Typography>
                        <IconButton onClick={() => handleIconToggle("endPointType")} size="small" sx={{ ml: 1 }}>
                            {icons[iconStates["endPointType"] || 0]}
                        </IconButton>
                    </Box>
                ),
            },
            {
                accessorKey: "progressBar",
                header: (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="body2">Progress Bar</Typography>
                        <IconButton onClick={() => handleIconToggle("progressBar")} size="small" sx={{ ml: 1 }}>
                            {icons[iconStates["progressBar"] || 0]}
                        </IconButton>
                    </Box>
                ),
                Cell: ({ cell }) => (
                    <Box sx={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'left', width: '100%' }}>
                        <CircularProgress
                            variant="determinate"
                            value={parseFloat(cell.getValue())}
                            sx={{ color: "#3b6a89" }}
                        />
                        <Box
                            sx={{
                                position: 'absolute',
                                top: '50%',
                                left: '12%',
                                transform: 'translate(-50%, -50%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Typography variant="caption" component="div" sx={{ color: 'text.secondary' }}>
                                {`${cell.getValue()}`}
                            </Typography>
                        </Box>
                    </Box>
                ),
            },
            {
                accessorKey: "totalRecords",
                header: (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="body2">Total Records</Typography>
                        <IconButton onClick={() => handleIconToggle("totalRecords")} size="small" sx={{ ml: 1 }}>
                            {icons[iconStates["totalRecords"] || 0]}
                        </IconButton>
                    </Box>
                ),
            },
        ],
        [iconStates]
    );


    const handlePageChange = (newPageIndex) => {
        setPageIndex(newPageIndex);
    };
    const handleStartChange = () => {
        setPageIndex(0);
    };

    const handleEndChange = () => {
        const totalPages = Math.ceil(getSyncData.totalRecord / pageSize);
        setPageIndex(totalPages - 1);
    };

    const handlePageSizeChange = (newPageSize) => {
        setPageSize(newPageSize);
        setPageIndex(0);
    };

    const handleDeleteConfirm = () => {
        setActionType('delete')
        setDeleteConfirm(true);
        setDeleteConfirmOpen(false);
        setSelectedRow(deleteConfirmId);
    };

    const handleDeleteCancel = () => {
        setDeleteConfirm(false);
        setDeleteConfirmOpen(false);
        setInfoOpen(false);
    };

    useEffect(() => {
        if (deleteConfirm) {
            setDeleteConfirm(false);
        }
    }, [deleteConfirmOpen])

    const openDeleteConfirmModal = (row) => {
        setDeleteConfirmId(row);
        setDeleteConfirmOpen(true);
    }

    const handleInfo = (row) => {
        setInfoOpen(true)
        setSelectedRow(row)
    }

    const handleDownload = (row) => {
        dispatch(downloadSyncService(row))
    }

    const handleStart = (row) => {
        setActionType('start');
        setSelectedRow(row);
        setClickStart((prev) => ({ ...prev, [row.id]: true }));
    };

    const handleStop = (row) => {
        setClickStart((prev) => ({ ...prev, [row.id]: false }));
        setActionType('stop');
        setSelectedRow(row);
    };

    const handleSearchChange = (event) => {
        event.preventDefault();
        setSearchQuery(event.target.value);
    };

    const handleRefresh = () => {
        dispatch(getSyncService(pageSize, pageIndex, '', '', ''))
    }

    return (<>
        <SyncServiceDialog open={openDialog} onClose={handleClose} />
        <div style={{ backgroundColor: "#dcebfed9", height: "86vh", padding: "15px", overflow: "hidden", border: "none" }} className="Admin">
            <div className={"d-flex col-sm-12 white_paper before-login"} style={{ backgroundColor: "#fff", overflow: "hidden", borderRadius: "5px", padding: "0px", height: "100%" }}>
                <div className={"col-sm-12 before-login-header "} style={{ marginTop: "25px" }}>

                    <div
                        style={{
                            display: "block",
                            width: "100%",
                            overflow: "auto",
                            padding: "0px 20px",
                        }}
                    >
                        <MaterialReactTable
                            muiTabEditIconleHeadCellProps={{
                                sx: {
                                    backgroundColor: "#286685",
                                    color: "#fff",
                                    boxShadow: "none !important",
                                },
                            }}
                            muiTableProps={{
                                sx: {
                                    border: "none",
                                    boxShadow: "none !important",
                                },
                            }}
                            muiTablePaperProps={{
                                sx: {
                                    boxShadow: "none !important",

                                    width: "100%",
                                    position: "relative",
                                    display: "block",
                                },
                            }}
                            muiTableContainerProps={{
                                sx: {
                                    maxHeight: "59vh",
                                    boxShadow: "none !important",

                                    overflowY: "auto",
                                    overflowX: "auto",
                                },
                            }}
                            muiTableHeadCellProps={{
                                sx: {
                                    backgroundColor: "#286685",
                                    boxShadow: "none !important",

                                    color: "#fff",
                                },
                            }}
                            muiTableBodyRowProps={({ row, index }) => ({
                                sx: {
                                    cursor: "pointer",
                                    boxShadow: "none !important",

                                    backgroundColor: row.getIsSelected()
                                        ? "bold"
                                        : index % 2 === 0
                                            ? "#cfd5e959"
                                            : "white",
                                },
                            })}
                            muiTableBodyProps={{
                                sx: {
                                    "& tr:nth-of-type(odd)": {
                                        backgroundColor: "#cfd5e959",
                                        // textAlign:"left"
                                    },
                                    "& td": {
                                        padding: "0.5rem",
                                        borderBottom: "1px solid #ccc",
                                        // textAlign:"left"

                                    },
                                },
                            }}
                            columns={columns}
                            data={Data}
                            enableRowActions={true}
                            enableEditing={false}
                            enableStickyHeader={true}
                            enableStickyFooter={false}
                            enableDensityToggle={false}
                            enableFullScreenToggle={false}
                            positionActionsColumn="last"
                            editDisplayMode="row"
                            enableFilters={false}
                            enableHiding={false}
                            enablePagination={false}
                            enableGlobalFilter={false}
                            enableSorting={false}
                            enableColumnActions={false}

                            renderTopToolbarCustomActions={({ table }) => (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        width: "100%",
                                        marginTop: "5px",
                                    }}
                                >
                                    {/* Create Button on the Left */}
                                    <Tooltip title="Create Job">
                                        <Button
                                            startIcon={<AddIcon />}
                                            variant="contained"
                                            component="span"
                                            style={{ backgroundColor: "#286685", color: "white" }}
                                            onClick={handleClick}
                                        >
                                            Create
                                        </Button>

                                    </Tooltip>

                                    <div>
                                        <style>
                                            {`
                        .MuiOutlinedInput-adornedEnd {
                          height: 35px !important;
                          padding: 0px !important;
                        }     
                      `}
                                        </style>
                                        <TextField
                                            variant="outlined"
                                            placeholder="Search"
                                            value={searchQuery}
                                            onChange={handleSearchChange}
                                            sx={{ width: '250px' }}
                                            InputProps={{
                                                endAdornment: (
                                                    <IconButton>
                                                        <SearchOutlined />
                                                    </IconButton>
                                                ),
                                            }}
                                        />
                                        <Tooltip title="refresh">
                                            <IconButton>
                                                <RefreshIcon style={{ color: "#286685" }} onClick={handleRefresh} />
                                            </IconButton>
                                        </Tooltip></div>
                                </div>
                            )}


                            renderRowActions={({ row, table }) => (
                                <Box sx={{ display: "flex", flexWrap: "nowrap" }}>


                                    {clickStart[row.original.id] ? (
                                        <Tooltip title="Stop">
                                            <IconButton
                                                className="actionIcon"
                                                onClick={() => {

                                                    handleStop(row.original)
                                                }
                                                }
                                            >
                                                <PauseIcon />
                                            </IconButton>
                                        </Tooltip>
                                    ) : (
                                        <Tooltip title="Start">
                                            <IconButton
                                                className="actionIcon"
                                                onClick={() => {
                                                    handleStart(row.original)
                                                }}
                                            >
                                                <PlayArrowIcon />
                                            </IconButton>
                                        </Tooltip>
                                    )}





                                    <Tooltip title="Information">
                                        <IconButton
                                            className="actionIcon"
                                            onClick={() => { handleInfo(row.original) }}
                                        >
                                            <InfoIcon />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip title="Download Log's">
                                        <IconButton
                                            className="actionIcon"
                                            onClick={() => { handleDownload(row.original) }}
                                        >
                                            <DownloadIcon />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip title="Delete">
                                        <IconButton
                                            className="actionIcon"
                                            onClick={() => {
                                                openDeleteConfirmModal(row.original);
                                            }}
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    </Tooltip>


                                </Box>
                            )}

                            renderBottomToolbarCustomActions={({ table }) => (
                                <>
                                    <div style={{ marginLeft: "auto" }}>
                                        <span>Rows per Page </span>&nbsp;
                                        <FormControl variant="standard" size="small">
                                            <Select
                                                value={pageSize}
                                                onChange={(e) =>
                                                    handlePageSizeChange(Number(e.target.value))
                                                }
                                            >
                                                <MenuItem value={5}>5</MenuItem>
                                                <MenuItem value={10}>10</MenuItem>
                                                <MenuItem value={20}>20</MenuItem>
                                                <MenuItem value={50}>50</MenuItem>
                                                <MenuItem value={100}>100</MenuItem>
                                            </Select>
                                        </FormControl>
                                        &nbsp;
                                        <span>
                                            {pageIndex * pageSize + 1}-
                                            {Math.min(
                                                pageIndex * pageSize + pageSize,
                                                getSyncData.totalRecord
                                            )}{" "}
                                            of &nbsp;
                                            {getSyncData.totalRecord}&nbsp;
                                        </span>
                                        <FirstPageIcon
                                            onClick={() => {
                                                if (pageIndex !== 0) {
                                                    handleStartChange();
                                                }
                                            }}
                                            style={{
                                                cursor: pageIndex === 0 ? "not-allowed" : "pointer",
                                                color: pageIndex === 0 ? "rgba(0, 0, 0, 0.26)" : "inherit",
                                            }}
                                        />
                                        <NavigateBeforeIcon
                                            onClick={() => {
                                                if (pageIndex !== 0) {
                                                    handlePageChange(pageIndex - 1);
                                                }
                                            }}
                                            style={{
                                                cursor: pageIndex === 0 ? "not-allowed" : "pointer",
                                                color: pageIndex === 0 ? "rgba(0, 0, 0, 0.26)" : "inherit",
                                            }}
                                        />
                                        <NavigateNextIcon
                                            onClick={() => {
                                                if (
                                                    (pageIndex + 1) * pageSize <
                                                    getSyncData.totalRecord
                                                ) {
                                                    handlePageChange(pageIndex + 1);
                                                }
                                            }}
                                            style={{
                                                cursor:
                                                    (pageIndex + 1) * pageSize >=
                                                        getSyncData.totalRecord
                                                        ? "not-allowed"
                                                        : "pointer",
                                                color:
                                                    (pageIndex + 1) * pageSize >=
                                                        getSyncData.totalRecord
                                                        ? "rgba(0, 0, 0, 0.26)"
                                                        : "inherit",
                                            }}
                                        />
                                        <LastPageIcon
                                            onClick={() => {
                                                if (
                                                    (pageIndex + 1) * pageSize <
                                                    getSyncData.totalRecord
                                                ) {
                                                    handleEndChange();
                                                }
                                            }}
                                            style={{
                                                cursor:
                                                    (pageIndex + 1) * pageSize >=
                                                        getSyncData.totalRecord
                                                        ? "not-allowed"
                                                        : "pointer",
                                                color:
                                                    (pageIndex + 1) * pageSize >=
                                                        getSyncData.totalRecord
                                                        ? "rgba(0, 0, 0, 0.26)"
                                                        : "inherit",
                                            }}
                                        />
                                    </div>
                                </>
                            )}
                        />
                    </div>

                    <div>
                        <Dialog open={deleteConfirmOpen} onClose={handleDeleteCancel}>
                            <DialogTitle
                                style={{ backgroundColor: "#3b6a89", color: "white" }}
                            >
                                Delete Confirmation
                            </DialogTitle>
                            <DialogContent>
                                <p>Are you sure you want to delete the item?</p>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleDeleteCancel} color="primary">
                                    Cancel
                                </Button>
                                <Button
                                    style={{ backgroundColor: "#3b6a89", color: "white" }}
                                    onClick={handleDeleteConfirm}
                                    color="error"
                                >
                                    Delete
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </div>


                    <div>
                        <Dialog open={infoOpen} onClose={handleDeleteCancel}>
                            <DialogTitle style={{ backgroundColor: "#3b6a89", color: "white" }}>
                                Information of {selectedRow?.rig || ""}
                            </DialogTitle>
                            {selectedRow?.endPointType === 'YellowHammer' ?
                                <DialogContent>
                                    <table style={{ border: "1px solid grey", width: "100%", borderCollapse: "collapse" }}>
                                        <tbody>
                                            <tr>
                                                <td className="dialogTable"><b>API Key</b></td>
                                                <td className="dialogTable">{selectedRow?.apiKey || ""}</td>
                                            </tr>
                                            <tr>
                                                <td className="dialogTable"><b>Client Id</b></td>
                                                <td className="dialogTable">{selectedRow?.clientId || ""}</td>
                                            </tr>
                                            <tr>
                                                <td className="dialogTable"><b>Host</b></td>
                                                <td className="dialogTable">{selectedRow?.host || ""}</td>
                                            </tr>
                                            <tr>
                                                <td className="dialogTable"><b>Port</b></td>
                                                <td className="dialogTable">{selectedRow?.port || ""}</td>
                                            </tr>
                                            <tr>
                                                <td className="dialogTable"><b>Secure</b></td>
                                                <td className="dialogTable">{selectedRow?.isSecure || ""}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </DialogContent>
                                :
                                <DialogContent>
                                    <table style={{ border: "1px solid grey", width: "100%", borderCollapse: "collapse" }}>
                                        <tbody>
                                            <tr>
                                                <td className="dialogTable"><b>Date Format</b></td>
                                                <td className="dialogTable">{selectedRow?.dateFormat || ""}</td>
                                            </tr>
                                            <tr>
                                                <td className="dialogTable"><b>URL</b></td>
                                                <td className="dialogTable">{selectedRow?.url || ""}</td>
                                            </tr>
                                            <tr>
                                                <td className="dialogTable"><b>User Name</b></td>
                                                <td className="dialogTable">{selectedRow?.userName || ""}</td>
                                            </tr>
                                            <tr>
                                                <td className="dialogTable"><b>Version</b></td>
                                                <td className="dialogTable">{selectedRow?.version || ""}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </DialogContent>
                            }
                            <DialogActions>
                                <Button onClick={handleDeleteCancel} color="primary">
                                    Cancel
                                </Button>
                            </DialogActions>
                        </Dialog>

                    </div>

                </div>
            </div>
        </div>
    </>)
}

export default SyncService;